import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { PeriodsAgo } from "../../../@types/custom";
import * as React from "react";
import { useTranslation } from "react-i18next";
import type { ChangeEvent } from "react";

type PeriodsSelectProps = {
  value: PeriodsAgo;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
};

export function PeriodsSelect(props: PeriodsSelectProps): React.ReactElement {
  const { value, onChange } = props;
  const { t } = useTranslation();
  return (
    <FormControl variant="outlined" sx={{ minWidth: "120px" }}>
      <InputLabel htmlFor="periods-picker">{t("general.period")}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label="Period"
        inputProps={{
          name: "age",
          id: "periods-picker"
        }}
      >
        <MenuItem value={PeriodsAgo.week}>{t("general.week")}</MenuItem>
        <MenuItem value={PeriodsAgo.month}>{t("general.month")}</MenuItem>
        <MenuItem value={PeriodsAgo.threeMonths}>{t("general.threeMonths")}</MenuItem>
        <MenuItem value={PeriodsAgo.sixMonths}>{t("general.sixMonths")}</MenuItem>
        <MenuItem value={PeriodsAgo.year}>{t("general.year")}</MenuItem>
        <MenuItem value={PeriodsAgo.custom}>{t("general.custom")}</MenuItem>
      </Select>
    </FormControl>
  );
}
